import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { Table } from '@dreryk/react-components';

import { usePractitionersTableColumns, usePractitionersTableDataConfiguration } from './PractitionersTable.hooks';

// TODO DREGAB-4881 Component should be placed in egabinet-personnel-frontend, but can't be because of circular deps
export const PractitionersTable = (): JSX.Element => {
   const dataConfiguration = usePractitionersTableDataConfiguration();
   const columns = usePractitionersTableColumns(dataConfiguration.refetch);

   return (
      <Table<PractitionerView>
         testId={'practitioners'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
      />
   );
};
